import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { account as accountGetter, hasAccountPermission as hasAccountPermissionGetter } from '@/store/modules/account/getters';
import { useStore } from '@/utils/store';

// TODO give specific type to account
type Account = unknown;
export const useAccountGetters = () => {
	const { getter } = useStore();
	return {
		account: getter<Account | undefined>(accountGetter),
		hasAccountPermission: getter<(permission: `${AccountPermissions}`) => boolean>(hasAccountPermissionGetter),
	};
};
